var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_64_308)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3819 18.3801H18.5112V31.634H14.3819V18.3801ZM16.4465 11.7935C17.7659 11.7935 18.8334 12.861 18.8334 14.1804C18.8334 15.4997 17.7659 16.5673 16.4465 16.5673C15.1272 16.5673 14.0496 15.4997 14.0496 14.1804C14.0496 12.8711 15.1171 11.7935 16.4465 11.7935Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0894 18.3802H25.0373V20.193H25.0877C25.6416 19.1456 26.9811 18.0479 28.9853 18.0479C33.1548 18.0479 33.9303 20.7873 33.9303 24.3626V31.6341H29.8212V25.1884C29.8212 23.6475 29.791 21.6735 27.676 21.6735C25.5308 21.6735 25.2085 23.3454 25.2085 25.0776V31.6341H21.0894V18.3802Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_308",
    x1: 7.02536,
    y1: 7.03191,
    x2: 40.9686,
    y2: 40.9751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a7c1a8faa15e9b039e70a0a54ac8b56e.svg";
export { ForwardRef as ReactComponent };